import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-successful-payment',
  templateUrl: './popup-successful-payment.component.html',
  styleUrls: ['./popup-successful-payment.component.scss']
})
export class PopupSuccessfulPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
